import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export const stripMarkdown = (text: string): string => {
  return text
    .replace(/^##\s+/gm, "")
    .replace(/^- /gm, "")
    .replace(/\*\*(.+?)\*\*/g, "$1")
    .replace(/_(.+?)_/g, "$1")
    .replace(/\n+/g, " ")
    .trim();
};

type MarkdownContentProps = {
  content: string;
  className?: string;
};

export const MarkdownContent = ({
  content,
  className,
}: MarkdownContentProps) => {
  return (
    <div className={className}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          h1: ({ children }) => <h1 className="text-base font-semibold">{children}</h1>,
          h2: ({ children }) => <h2 className="text-sm font-semibold">{children}</h2>,
          h3: ({ children }) => <h3 className="text-sm font-medium">{children}</h3>,
          p: ({ children }) => <p className="leading-relaxed">{children}</p>,
          ul: ({ children }) => <ul className="list-disc space-y-1 pl-4">{children}</ul>,
          ol: ({ children }) => <ol className="list-decimal space-y-1 pl-4">{children}</ol>,
          li: ({ children }) => <li>{children}</li>,
          blockquote: ({ children }) => (
            <blockquote className="border-border border-l-2 pl-3 italic">{children}</blockquote>
          ),
          a: ({ children, href }) => (
            <a
              href={href}
              target="_blank"
              rel="noreferrer"
              className="text-primary underline underline-offset-2"
            >
              {children}
            </a>
          ),
          code: ({ children }) => (
            <code className="bg-muted rounded px-1.5 py-0.5 text-[0.85em]">{children}</code>
          ),
          hr: () => <hr className="border-border my-2" />,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};
